export default (val, thSep, dcSep) => {
  // Проверка указания разделителя разрядов
  if (!thSep) thSep = ' ';
  // Проверка указания десятичного разделителя
  if (!dcSep) dcSep = '.';
  var res = val.toString();
  var lZero = val < 0; // Признак отрицательного числа
  // Определение длины форматируемой части
  var fLen = res.indexOf('.'); // До десятичной точки
  res += fLen > -1 ? '00' : '.00';
  fLen = fLen > -1 ? fLen : res.indexOf('.');
  // Выделение временного буфера
  var tmpRes = res.substring(fLen, fLen + 3);
  var cnt = -1;
  for (var ind = fLen; ind > 0; ind--) {
    // Формируем временный буфер
    cnt++;
    if (cnt % 3 === 0 && ind !== fLen && (!lZero || ind > 1)) {
      tmpRes = thSep + tmpRes;
    }
    tmpRes = res.charAt(ind - 1) + tmpRes;
  }

  return tmpRes.replace('.', dcSep);
};
